export default "__VITE_ASSET__FKW6qOIiMWcVdWo2taY49w__";